import configureLogger from "asos-web-logging";
import { name } from "../../package.json";

export default configureLogger({
  moduleName: name
});
